export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/containers/index.ts